import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import SectionLabel from "./SectionLabel";

const GoogleG = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden>
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18A10.97 10.97 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.83z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38z"
    />
  </svg>
);

export default function Testimonials() {
  return (
    <section
      id="avis"
      className="relative py-24 md:py-32 bg-[#1C1917] overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#C5A059]/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 md:mb-20 text-center max-w-2xl mx-auto"
        >
          <div className="flex items-center gap-3 mb-5 justify-center">
            <span className="w-8 h-px bg-[#C5A059]" />
            <span className="text-[#C5A059] text-[11px] tracking-[0.4em] uppercase font-body">
              Témoignages
            </span>
            <span className="w-8 h-px bg-[#C5A059]" />
          </div>
          <h2 className="font-display font-light text-[#F9F6F0] text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            Ils ont vécu<br />
            <span className="italic text-[#E6CB89]">l'expérience Harmony</span>
          </h2>
          <div className="mt-8 flex items-center justify-center gap-3 text-[#F9F6F0]/80">
            <GoogleG />
            <span className="font-body text-sm">
              <span className="font-medium text-[#F9F6F0]">4.9 / 5</span> sur Google · plus de 80 avis
            </span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="bg-white/[0.04] backdrop-blur-md border border-white/10 rounded-2xl p-6 hover:bg-white/[0.07] hover:-translate-y-1 transition-all duration-500"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star
                    key={j}
                    strokeWidth={1.2}
                    className="w-4 h-4 fill-[#C5A059] text-[#C5A059]"
                  />
                ))}
              </div>
              <p className="text-[#F9F6F0]/85 font-light leading-relaxed text-sm mb-6">
                "{t.text}"
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-white/10">
                <div>
                  <p className="font-display text-[#F9F6F0] text-lg">{t.name}</p>
                  <p className="text-[#F9F6F0]/50 text-xs font-light">{t.date}</p>
                </div>
                <GoogleG />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
